import { render, staticRenderFns } from "./agentLayout.vue?vue&type=template&id=78d6894b&scoped=true&"
import script from "./agentLayout.vue?vue&type=script&lang=js&"
export * from "./agentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6894b",
  null
  
)

export default component.exports